import indexMutations from "./indexStore/mutations";
// 公有内容直接写入。
var mutations = {
    ...indexMutations
};
export default mutations;